export default __webpack_public_path__ + "static/media/icon-monCompte.eaad3f67.svg";